import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DetailApprovalDialogComponent } from '../../reimbursement-approval/action-reimbursement-approval/detail-approval-dialog/detail-approval-dialog.component';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ReimburseService } from '../../../../core/api/reimburse.service';
import { ReimburseLogService } from '../../../../core/api/reimburse-log.service';
import { TagService } from '../../../../core/api/tag.service';
import { FileService } from '../../../../core/api/file.service';
import { HelpersService } from '../../../../core/services/helpers.service';
import { AuthService } from '../../../../core/services/auth.service';
import { LoadingService } from '../../../../core/services/loading.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DirectiveModule } from '../../../../core/directives';
import { ExpanseCategoryService } from '../../../../core/api/expanse-category.service';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { FilePreviewComponent } from '../../../../components/file-preview/file-preview.component';
import moment from 'moment/moment';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-resubmit-reimbursement',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatDividerModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './resubmit-reimbursement.component.html',
  styleUrl: './resubmit-reimbursement.component.scss',
})
export class ResubmitReimbursementComponent {
  displayedColumns: string[] = [
    'user',
    'team',
    'sequence',
    'date',
    'status',
    'notes',
    'action',
  ];
  reimburse: any = null;
  reimburseLogs: any[] = [];
  tag: any[] = [];
  approvalList: any[] = [];
  latestApproval: any = null;
  id: any;
  m: string;
  currentUser: any;
  finishApprove = false;

  uploadStatus: boolean = false;
  fileExists: boolean = false;
  fileUrl: any;
  file: any;
  fileName: string = '';
  uploadedFiles: any[] = [];

  form: FormGroup;

  expenseCategory: any[] = [];

  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private reimburseService: ReimburseService,
    private reimburseLogService: ReimburseLogService,
    private tagService: TagService,
    private fileService: FileService,
    private helpers: HelpersService,
    public authService: AuthService,
    private loadingService: LoadingService,
    private expanseCategoryService: ExpanseCategoryService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.currentUser = this.authService.getLoggedUser();
    this.form = this.fb.group({
      title: [null, [Validators.required]],
      amount: [null, [Validators.required]],
      currency: ['Rp', [Validators.required]],
      expanseCategoryId: [null, [Validators.required]],
      date: [null, [Validators.required]],
      tagId: [null, [Validators.required]],
      description: [null, [Validators.required]],
      location: [null, [Validators.required]],
      fileId: [null, [Validators.required]],
    });
    this.getReimburse();
    this.getTag();
    this.getExpanseCategory();
  }

  getReimburse() {
    this.loadingService.startLoading();
    this.reimburseService.getById(this.id).then(
      (data: any) => {
        this.reimburse = data;

        // Jalankan semua proses terkait secara paralel
        const logPromise = this.getReimburseLog(this.reimburse.id);
        const approvalListPromise = this.getApprovalList(this.reimburse.id);

        if (data.file) {
          this.file = data.file;
          this.fileExists = true;
          data['fileId'] = data.file.id;
          this.fileName = data.file.fileName;
          this.uploadedFiles = [data.file];
        }
        if (data.fileIds?.length && !this.uploadedFiles.length) {
          this.uploadedFiles = data.fileIds.map((id: number) => ({
            id,
            fileName: `File #${id}`,
          }));
        }
        data['expanseCategoryId'] = data.expanseCategory.id;
        data['tagId'] = data.tag.id;
        this.form.patchValue(data);

        Promise.all([logPromise, approvalListPromise]).finally(() => {
          this.loadingService.endLoading();
        });
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getReimburseLog(reimburseId: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.reimburseLogService.getReimburseLog(reimburseId).then(
        (resp: any) => {
          this.reimburseLogs = resp.map((item: any) => {
            return {
              ...item,
              updated_at: (item.updated_at && moment(item.updated_at).isValid()
                ? moment(item.updated_at).utcOffset(7).format('YYYY-MM-DD HH:mm:ss')
                : null)
            }
          });
          const imagePromises = this.reimburseLogs.map((item: any) =>
            this.getImageUrl(item.creator)
          );

          Promise.all(imagePromises).finally(() => {
            resolve();
          });
        },
        (error) => {
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  getTag() {
    this.loadingService.startLoading();
    this.tagService.getAllData().then(
      (res) => {
        this.loadingService.endLoading();
        this.tag = res;
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getExpanseCategory(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.expanseCategoryService.getAllData().then(
        (res) => {
          this.expenseCategory = res.filter(
            (item: any) => item.type == 'Reimbursment'
          );
          resolve();
        },
        (error) => {
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  getApprovalList(reimburseId: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.reimburseService.getApprovalList(reimburseId).then(
        (resp: any) => {
          this.approvalList = resp;
          if (this.approvalList.length) {
            this.latestApproval =
              this.approvalList[this.approvalList.length - 1].approval_note;
          }
          resolve();
        },
        (error) => {
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  private getImageUrl(item: any): Promise<void> {
    return new Promise((resolve) => {
      if (item.file) {
        this.loadingService.startLoading();
        this.fileService.download(item.file?.id).subscribe(
          (res) => {
            this.loadingService.endLoading();
            item['imageUrl'] = URL.createObjectURL(res);
            resolve();
          },
          (error) => {
            this.loadingService.endLoading();
            item['imageUrl'] = null;
            resolve();
          }
        );
      } else {
        item['imageUrl'] = null;
        resolve();
      }
    });
  }

  download(fileItem?: any) {
    const file = this.helpers.resolveTargetFile(fileItem, this.reimburse);
    if (file) {
      const isMobile = window.innerWidth < 768;
      const canPreviewInline = this.helpers.canPreviewInline(file);

      if (isMobile || !canPreviewInline) {
        this.openFileInNewTab(file);
        return;
      }

      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxHeight: '95vh',
          maxWidth: '70vw',
          data: { file },
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  private openFileInNewTab(file: any) {
    this.loadingService.startLoading();
    this.fileService.download(file?.id).subscribe(
      (res) => {
        this.loadingService.endLoading();
        const url = URL.createObjectURL(res);
        const opened = window.open(url, '_blank', 'noopener,noreferrer');
        if (!opened) {
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.target = '_blank';
          anchor.rel = 'noopener noreferrer';
          anchor.click();
        }
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getFileItems(element: any): any[] {
    return this.helpers.normalizeFileItems(element);
  }

  resubmit() {
    console.log('Resubmit');
    console.log(this.form.value);
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const data = this.form.value;
      data['amount'] = this.helpers.parseAmount(data.amount);
      data['status'] = 'Sent';
      if (this.uploadedFiles.length) {
        data['fileIds'] = this.uploadedFiles.map((item: any) => item.id);
        data['fileId'] = this.uploadedFiles[0].id;
      }
      this.dialog
        .open(ConfirmDialogComponent, {
          width: '545px',
          maxHeight: '95vh',
          panelClass: 'confirm-dialog',
          data: {
            title: `Confirm Resubmit Reimbursement`,
            message: `Changes to the Reimbursement cannot be undone once saved. Are you sure you want to proceed?`,
          },
        })
        .afterClosed()
        .subscribe((result: any) => {
          if (result) {
            this.loadingService.startLoading();
            this.reimburseService
              .reimburse(this.id, data)
              .then(() => {
                this.loadingService.endLoading();
                this.helpers.sbSuccess('Resubmit Success!');
                this.router.navigate(['/dashboard/reimbursement-claimer']);
              })
              .catch((error) => {
                this.loadingService.endLoading();
                this.helpers.sbError(error.message);
              });
          }
        });
    } else if (this.form.get('fileId')?.invalid) {
      this.helpers.sbError(
        'Please upload file firstly and fill all required fields!'
      );
    } else {
      this.helpers.sbError('Lengkapi form terlebih dahulu!');
    }
  }

  detail(data: any, sequence: any): void {
    data['sequence'] = sequence;
    this.dialog
      .open(DetailApprovalDialogComponent, {
        width: '700px',
        maxHeight: '95vh',
        data,
      })
      .afterClosed()
      .subscribe((item) => {
        if (item) {
        }
      });
  }

  uploadFile(event: Event) {
    this.uploadStatus = true;
    const target = event.target as HTMLInputElement | null;
    const fileList = target?.files;
    if (fileList?.length) {
      const files = Array.from(fileList);
      const uploads = files.map(
        (file) =>
          new Promise<any>((resolve, reject) => {
            try {
              this.fileService.upload(file).subscribe({
                next: (res: any) => {
                  if (
                    res?.type === HttpEventType.Response &&
                    res?.body?.data
                  ) {
                    resolve(res.body.data);
                  }
                },
                error: (err: any) => reject(err),
              });
            } catch (err: any) {
              reject(err);
            }
          })
      );
      this.loadingService.startLoading();
      Promise.all(uploads)
        .then((results: any[]) => {
          const uploaded = results.filter(Boolean);
          if (!uploaded.length) return;
          this.uploadedFiles = [...this.uploadedFiles, ...uploaded];
          this.file = this.uploadedFiles[0];
          this.form.get('fileId')?.setValue(this.uploadedFiles[0].id);
          this.fileExists = true;
          this.fileName =
            this.uploadedFiles.length === 1
              ? this.uploadedFiles[0].fileName
              : `${this.uploadedFiles.length} files selected`;
        })
        .catch((err: any) => {
          this.helpers.sbError(err.message);
        })
        .finally(() => {
          this.loadingService.endLoading();
          this.uploadStatus = false;
          if (target) target.value = '';
        });
    } else {
      this.helpers.sbError('Tidak ada file yang akan diupload!');
      this.uploadStatus = false;
      if (target) target.value = '';
    }
  }

  removeUploadedFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
    if (!this.uploadedFiles.length) {
      this.file = null;
      this.fileName = '';
      this.fileExists = false;
      this.form.get('fileId')?.setValue(null);
      return;
    }
    this.file = this.uploadedFiles[0];
    this.fileName =
      this.uploadedFiles.length === 1
        ? this.uploadedFiles[0].fileName
        : `${this.uploadedFiles.length} files selected`;
    this.form.get('fileId')?.setValue(this.uploadedFiles[0].id);
  }
}
